import { Component, ContentChildren, QueryList } from '@angular/core';
import { TabPanelComponent } from '../tab-panel/tab-panel.component';

@Component({
    selector: 'tab-view',
    templateUrl: './tab-view.component.html',
    styleUrls: ['./tab-view.component.scss']
})
export class TabViewComponent  {
    @ContentChildren(TabPanelComponent) tabs!: QueryList<TabPanelComponent>;
    activeIndex = 0;

    get tabArray(): TabPanelComponent[] {
        return this.tabs?.toArray() ?? [];
    }
}
